import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var da = {
  language: 'da',
  country: 'dk',
  name: 'Dansk',
  embeddedLocale: merge(error, login),
  flags: ['DK'],
};

export { da as default };
